<template>
  <div class="export-language-container">

    <h3 class="export-language-title">EXPORT LANGUAGES</h3>
    <div>
      A window will open to select the language you want to download.<br />
      At the end of the process, a spreadsheet file (CSV) will be downloaded
      automatically.
    </div>
    <b-button
      class="export-language-button"
      variant="primary"
      @click="showModal = true"
    >
      EXPORT LANGUAGE
    </b-button>
    <b-modal
      id="modalInfo"
      v-model="showModal"
      modal-class="modalInfo"
      title="Export language"
    >
      <p>
        Please select the language you want to download. This process will
        download spreadsheet file (CSV) automatically.
      </p>
      <b-select v-model="selectedLanguage" :options="languages" />
      <div slot="modal-footer" class="w-100">
        <b-btn variant="primary" @click="showModal = false"> Close </b-btn>
        <b-btn variant="primary" @click="getCsv()"> Export </b-btn>
      </div>
    </b-modal>
  </div>
</template>


<script>
import Vue from "vue";
import Icon from "vue-awesome/components/Icon";
import "vue-awesome/icons";
import "@/assets/icons/icons";
import { axiosCall } from "../../../../utils/axiosCall";

Vue.component("Icon", Icon);

export default {
  name: "LabelsExport",
  data: function () {
    return {
      showModal: false,
      languages: [],

      selectedLanguage: null,
    };
  },
  created: async function () {
    await this.getLangs();
  },
  methods: {
    getLangs: async function () {
      await axiosCall({ url: "/Langs/AvailableLanguages", method: "GET" }).then(
        async (response) => {
          this.languages = response.data.map((avL) => {
            return {
              text: avL.language,
              value: avL.id,
            };
          });
          if (this.languages && this.languages.length) {
            this.selectedLanguage = this.languages[0].value;
          }
        }
      );
    },
    getCsv: async function () {
      await axiosCall({
        url: `/LabelExport/csv/${this.selectedLanguage}.csv`,
        method: "GET",
      }).then(async (response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `${this.selectedLanguage}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.showModal = false;
      });
    },
  },
};
</script>
<style lang="scss">
.export-language {
  &-container {
    padding: 30px 60px;
  }

  &-button {
    padding: 15px;
    margin-top: 40px;
    border-radius: 5px !important;
  }

  &-last-time {
    font-size: 0.8rem;
  }

  &-title {
    margin-bottom: 25px;
  }
}
</style>
